import { render, staticRenderFns } from "./ApplicantDetails.vue?vue&type=template&id=8cc319c2&scoped=true"
import script from "./ApplicantDetails.vue?vue&type=script&lang=js"
export * from "./ApplicantDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicantDetails.vue?vue&type=style&index=0&id=8cc319c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc319c2",
  null
  
)

export default component.exports